import React from 'react';
import PropTypes from 'prop-types';
import { inlineCardCalloutPlaceholder } from '@/constants';
import InlineCardCalloutNotification from '../../common/InlineCardCalloutNotification';
import InlinePlaceholderMessage from '../../common/InlinePlaceholderMessage';
import { loungeDetailsProductLabelClasses } from './constants';

const LoungeDetailsCardPickerMessage = ({ className, text }) => (
  <InlinePlaceholderMessage
    text={text}
    placeholder={inlineCardCalloutPlaceholder}
    className={className}
    replacement={
      <InlineCardCalloutNotification
        hideImage
        variant="loungeDetails"
        className={loungeDetailsProductLabelClasses}
      />
    }
  />
);

LoungeDetailsCardPickerMessage.propTypes = {
  className: PropTypes.string.isRequired,
  text: PropTypes.string,
};

export default LoungeDetailsCardPickerMessage;
